import React from 'react';
import Select, { components } from 'react-select';
import { defaultTemplate } from 'core/hoc';
import { renderIf, isSome } from 'core/utils';
import { CostBreakdownTooltip } from 'common/tooltips';
import _ from 'lodash';

const BaasicSelectTemplate = ({
	t,
	placeholder,
	options,
	reference,
	validation,
	required,
	onDelete,
	label,
	value,
	orderBy,
	isSuperAdmin,
	canDelete,
	hasOrder,
	useCustomOption,
	isAddTemplate,
	wrapClassName,
	...props
}) => {
	if (placeholder) {
		placeholder = t(placeholder);
	}
	options = _.sortBy(options, orderBy || 'label');
	if (isAddTemplate) {
		options.unshift({ label: 'Add new template' });
	}
	const formatOptionLabel = ({ additionalinfo, label }) => (
		<div className="flex flex--secondary w--100">
			<span>{label}</span>
			{additionalinfo && <span>{additionalinfo}</span>}
		</div>
	);
	let labelHtml, errorHtml, field;
	let selector = '';
	if (props.field != null) {
		selector = `${props.field.name}`;
	} else if (placeholder != null) {
		selector = `${placeholder.toLowerCase().replace(/\s/g, '-')}`;
	}
	if (props.field) {
		field = props.field;
		const requiredMark =
			field.rules && field.rules.indexOf('required') !== -1 ? <span className="type--color--warning">*</span> : null;
		labelHtml = (
			<label htmlFor={field.id} id={selector + '-label'}>
				{t(field.label)} {requiredMark}
			</label>
		);
		errorHtml = renderIf(isSome(field) && isSome(field.error))(
			<p className="type--tny type--color--error spc--bottom--tny">{t(field.error)}</p>
		);
	}
	if (label) {
		labelHtml = <label>{t(label)}</label>;
	}
	const { Option } = components;
	const IconOption = props => {
		return (
			<Option {...props}>
				{
				props.data.extra != null &&
				  props.data.extra.rateComposition &&
				  props.data.extra.carrier.surplusCharge != 0 ? (
					// Render only if surcharge is defined
					<React.Fragment>
						<CostBreakdownTooltip
							idValue={props.value.carrierServiceId + props.value.carrierId}
							shippingCost={props.data.extra.rateComposition.cost}
							surplusCharge={props.data.extra.rateComposition.surcharge}
							total={props.data.extra.rateComposition.total}
							displayIcon={true}
						/>
					</React.Fragment>
				) : null}
				{props.data.extra.deliveryTimestamp && <span>{props.data.extra.deliveryTimestamp}</span>}
			</Option>
		);
	};

	return (
		<React.Fragment>
			<div className={`react-select-override ${wrapClassName}`}>
				{labelHtml}
				{errorHtml}
				<div className="flex flex--primary flex--no-wrap">
					<Select
						inputId={selector != null ? `${selector}-dropdown-input` : undefined}
						id={selector != null ? `${selector}-dropdown` : undefined}
						value={value}
						components={useCustomOption ? { Option: IconOption } : null}
						placeholder={placeholder}
						formatOptionLabel={formatOptionLabel}
						options={options}
						menuPlacement={'auto'}
						isDisabled={props.disabled}
						ref={ref => (reference != null ? reference(ref) : null)}
						className="flex--grow--1"
						classNamePrefix="react-select"
						{...props}
					/>
					{renderIf(
						field &&
							field.$rules &&
							field.$rules.includes('required') &&
							!isSome(field.error) &&
							field.$value &&
							validation
					)(
						<span className="type--lrg type--color--success spc--left--tny">
							<i className="fa fa-check-circle"></i>
						</span>
					)}
				</div>
			</div>
		</React.Fragment>
	);
};

export default defaultTemplate(BaasicSelectTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/components/select/BaasicSelectTemplate.jsx